var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { MenuItem, TextField, DropdownField, IconButton, Button, Link, useBreakpoint, } from '@one-thd/sui-atomic-components';
import { useForm, Controller, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Search, Close } from '@one-thd/sui-icons';
import { searchCreditCardValidationSchema } from './validation';
import { B2BCreditCardsFilterType, B2BCreditCardsFilterTypePlaceHolder, } from '../../../api/b2b/payments';
import { usePayments } from '../../../hooks/use-payments';
import { cardSortByMap, cardSortInputValues, } from '../../../constants/sort';
import { CreditCardStatusFilterMapping, CreditCardTypesTextMapping, } from '../../../constants/credit-card';
import { setCardSearchAnalytics, setCardSearchSortPostPageErrorAnalytics, setCardSortAnalytics, } from '../../../utils/payments-analytics';
export const CreditCardSortSearchBar = ({ triggerGetPaymentCards, onResetResults, }) => {
    var _a;
    const { isSearchActive, setAlertMessage, currentSortByValue, submittedSearchValue, submittedSearchType, isListView, } = usePayments();
    const screen = useBreakpoint('lg');
    const isSmallScreen = screen.lesser;
    const formMethods = useForm({
        resolver: yupResolver(searchCreditCardValidationSchema),
        mode: 'onTouched',
        defaultValues: {
            filterType: B2BCreditCardsFilterType.NOTHING,
            filterValue: '',
        },
    });
    const { control, formState: { errors: formErrors, isValid }, reset, trigger, watch, } = formMethods;
    const filterValue = watch('filterValue');
    const filterType = watch('filterType');
    const executeSort = (sortBy, ascendingOrder) => {
        triggerGetPaymentCards(1, submittedSearchType, submittedSearchValue, sortBy, ascendingOrder);
    };
    useEffect(() => {
        var _a;
        if ((_a = formErrors.filterValue) === null || _a === void 0 ? void 0 : _a.message) {
            setCardSearchSortPostPageErrorAnalytics(formErrors.filterValue.message);
        }
    }, [(_a = formErrors.filterValue) === null || _a === void 0 ? void 0 : _a.message]);
    const renderTextInput = () => {
        return (React.createElement("div", { className: "sui-grid sui-grid-cols-7" },
            React.createElement("div", { className: 'sui-grid ' + (filterValue ? 'sui-col-span-6' : 'sui-col-span-7') },
                React.createElement(Controller, { name: "filterValue", control: control, render: ({ field }) => {
                        var _a;
                        const { ref, value, name, onChange } = field, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                        const onChangeRevised = (event) => {
                            let newFilterValue = event.currentTarget.value;
                            // if exp date and the first two digits have been entered, automatically include the slash
                            if (filterType === B2BCreditCardsFilterType.expDate &&
                                newFilterValue.length === 2 &&
                                !filterValue.includes('/')) {
                                newFilterValue += '/';
                            }
                            onChange(newFilterValue);
                            trigger('filterValue');
                        };
                        return (React.createElement(TextField, { disabled: filterType === B2BCreditCardsFilterType.NOTHING, status: (formErrors === null || formErrors === void 0 ? void 0 : formErrors.filterValue) ? 'error' : undefined, statusMessage: (_a = formErrors === null || formErrors === void 0 ? void 0 : formErrors.filterValue) === null || _a === void 0 ? void 0 : _a.message, fullWidth: true, value: value, name: name, onChange: onChangeRevised, placeholder: B2BCreditCardsFilterTypePlaceHolder[filterType], id: "searchField", InputProps: {
                                style: {
                                    backgroundColor: 'var(--UI-Background-Fill-Background-Subtle, #F4F4F4)',
                                },
                                inputProps: Object.assign({}, rest),
                                endAdornment: value ? (React.createElement(IconButton, { onClick: () => {
                                        reset({ filterValue: '', filterType });
                                    }, icon: Close, iconSize: "small", "aria-label": "Clear" })) : (React.createElement(Search, { color: "medium", size: "small" })),
                            } }));
                    } })),
            filterValue && (React.createElement("div", { className: "sui-ml-2", style: { marginTop: '8px' } },
                React.createElement(Button, { disabled: !isValid, onClick: () => {
                        setAlertMessage(null);
                        triggerGetPaymentCards(1, filterType, filterValue, currentSortByValue.sortBy, currentSortByValue.ascendingOrder);
                        setCardSearchAnalytics(isListView, filterType, 'user entry');
                    } },
                    React.createElement(Search, { size: "small" }))))));
    };
    const renderSearchFieldDropdown = () => {
        if (filterType === B2BCreditCardsFilterType.status) {
            return (React.createElement(Controller, { name: "filterValue", key: filterType, control: control, render: ({ field }) => {
                    const { value, onChange } = field;
                    return (React.createElement(DropdownField, { fullWidth: true, value: value, dropdownProps: {
                            onChange: (event, newValue) => {
                                onChange(event);
                                triggerGetPaymentCards(1, filterType, newValue, currentSortByValue.sortBy, !!currentSortByValue.ascendingOrder);
                                setCardSearchAnalytics(isListView, filterType, newValue);
                            },
                            placeholder: B2BCreditCardsFilterTypePlaceHolder[filterType],
                        } }, CreditCardStatusFilterMapping.map((menuValue) => (React.createElement(MenuItem, { key: menuValue, value: menuValue }, menuValue)))));
                } }));
        }
        if (filterType === B2BCreditCardsFilterType.cardBrand) {
            return (React.createElement(Controller, { name: "filterValue", key: filterType, control: control, render: ({ field }) => {
                    const { value, onChange } = field;
                    return (React.createElement(DropdownField, { fullWidth: true, value: value, dropdownProps: {
                            onChange: (event, newValue) => {
                                onChange(event);
                                triggerGetPaymentCards(1, filterType, newValue.valueOf(), currentSortByValue.sortBy, !!currentSortByValue.ascendingOrder);
                                setCardSearchAnalytics(isListView, filterType, newValue);
                            },
                            placeholder: B2BCreditCardsFilterTypePlaceHolder[filterType],
                            maxItems: 8,
                            'data-testid': 'user-entry-card-choice-dropdown',
                        } }, Object.entries(CreditCardTypesTextMapping).map(([key, menuValue]) => (React.createElement(MenuItem, { key: key, value: key }, menuValue)))));
                } }));
        }
        return '';
    };
    const renderSearchField = () => {
        switch (filterType) {
            case B2BCreditCardsFilterType.NOTHING:
            case B2BCreditCardsFilterType.nickName:
            case B2BCreditCardsFilterType.cardLast4Digits:
            case B2BCreditCardsFilterType.expDate:
            case B2BCreditCardsFilterType.citiID:
                return renderTextInput();
            case B2BCreditCardsFilterType.status:
            case B2BCreditCardsFilterType.cardBrand:
                return renderSearchFieldDropdown();
            default:
                return '';
        }
    };
    const handleClearSearch = () => {
        const fType = B2BCreditCardsFilterType.NOTHING;
        const fValue = '';
        onResetResults(isListView);
        reset({ filterType: fType, filterValue: fValue });
        setAlertMessage(null);
    };
    return (React.createElement("div", { className: "sui-grid sm:sui-grid-cols-1 md:sui-grid-cols-2 2xl:sui-grid-cols-4 sui-w-full sui-gap-x-1 sui-mb-6" },
        React.createElement(FormProvider, Object.assign({}, formMethods),
            React.createElement("div", { className: "sui-grid sui-grid-rows-1 sui-flex" },
                React.createElement(Controller, { name: "filterType", control: control, render: ({ field }) => {
                        const { value, onChange } = field;
                        return (React.createElement(DropdownField, { value: value, label: "Search By", id: "searchByField", dropdownProps: {
                                onChange: (event, newValue) => {
                                    reset({ filterValue: '', filterType: newValue });
                                    onChange(event);
                                },
                                placeholder: 'Choose a Search Field',
                                'data-testid': 'searchByFieldTest',
                            } },
                            React.createElement(MenuItem, { disabled: true, value: B2BCreditCardsFilterType.NOTHING.valueOf() }, "Choose a Search Field"),
                            React.createElement(MenuItem, { value: B2BCreditCardsFilterType.cardBrand.valueOf() }, "Card Type"),
                            React.createElement(MenuItem, { value: B2BCreditCardsFilterType.nickName.valueOf() }, "Nickname"),
                            React.createElement(MenuItem, { value: B2BCreditCardsFilterType.expDate.valueOf() }, "Exp. Date"),
                            React.createElement(MenuItem, { value: B2BCreditCardsFilterType.cardLast4Digits.valueOf() }, "Card Number"),
                            React.createElement(MenuItem, { value: B2BCreditCardsFilterType.status.valueOf() }, "Status"),
                            React.createElement(MenuItem, { value: B2BCreditCardsFilterType.citiID.valueOf() }, "Citi Account ID")));
                    } }),
                React.createElement("div", { className: "sui-pt-4 sui-grid sui-grid-rows-1 sui-hidden md:sui-block" }, isSearchActive && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                React.createElement(Link, { component: "button", decoration: "underline", variant: "body-base", onClick: handleClearSearch }, "Clear Search")))),
            React.createElement("div", { className: "sui-pt-3 md:sui-pt-0 md:sui-pt-0 sui-mt-0 md:sui-mt-5 2xl:sui-mr-4" },
                renderSearchField(),
                React.createElement("div", { className: `sui-grid sui-grid-rows-1 ${isSearchActive ? 'sui-pt-4' : ''} sui-pb-4 sui-border-b-1 sui-border-primary sui-border-solid sui-block md:sui-hidden` }, isSearchActive && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                React.createElement(Link, { component: "button", decoration: "underline", variant: "body-base", onClick: handleClearSearch }, "Clear Search"))))),
        (!isListView || isSmallScreen) && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-grid sui-grid-rows-1 sui-mb-0 sui-pt-4 md:sui-pt-0 2xl:sui-ml-4 sui-pl-0 " },
                React.createElement(DropdownField, { value: currentSortByValue.sortBy, label: "Sort By", id: "sortByField", dropdownProps: {
                        onChange: (_event, sortType) => {
                            executeSort(sortType, true);
                            setCardSortAnalytics(isListView, sortType, cardSortByMap[sortType || 'Card Type'].orders[0]);
                        },
                        placeholder: 'Choose a Sort Field',
                        'data-testid': 'sortByFieldTest',
                    } }, cardSortInputValues.map((sortBy) => (React.createElement(MenuItem, { key: sortBy, value: sortBy }, sortBy))))),
            React.createElement("div", { className: `sui-grid sui-grid-rows-1 sui-mb-0 sui-pt-5 md:sui-pt-0 ${currentSortByValue.ascendingOrder === null
                    ? 'sui-hidden md:sui-block'
                    : ''}` },
                React.createElement(DropdownField, { value: currentSortByValue.ascendingOrder === null
                        ? null
                        : ['desc', 'asc'][+currentSortByValue.ascendingOrder], label: "Order", id: "sortByValueField", fullWidth: true, dropdownProps: {
                        onChange: (_event, ascendingOrder) => {
                            executeSort(currentSortByValue.sortBy, ascendingOrder === 'asc');
                            setCardSortAnalytics(isListView, currentSortByValue.sortBy
                                ? currentSortByValue.sortBy.toString()
                                : '', cardSortByMap[currentSortByValue.sortBy || 'Card Type']
                                .orders[ascendingOrder === 'asc' ? 0 : 1]);
                        },
                        placeholder: 'Choose a Sort Order',
                        'data-testid': 'sortByValueFieldTest',
                    } }, cardSortByMap[currentSortByValue.sortBy || 'Card Type'].orders.map((order, index) => (React.createElement(MenuItem, { key: order, value: index === 0 ? 'asc' : 'desc' }, order)))))))));
};
